/** @description 내부망 접속이 필요한 경로를 정의 */
export const networkConfig = [
  '/check-network',
  '/contract/caution',
  '/contract/contract-user-info',
  '/contract/contract-work-info',
  '/contract/phone-certificate',
  '/contract/contract-sign',
];
